import * as UI from '@brewlogix/blx-ui'
import * as React from 'react'

import { Brand, Location } from 'src/types/schema/graphql'

import classNames from 'classnames'
import AddressRow from './AddressRow'
import { FavoriteType } from 'src/features/favorites/types/enums/FavoriteType'
import LegacyFavoritesButton from 'src/features/favorites/components/LegacyFavoritesButton'

interface IHeader {
    brand?: Brand
    location?: Location
    isSticky: boolean
}

const Header: React.FC<IHeader> = ({ brand, location, isSticky }) => {
    const { address, title } = brand || location
    const { assets } = brand || location.brand
    const [transition, setTransition] = React.useState(false)

    React.useEffect(() => {
        setTransition(true)
        const timeOut = setTimeout(() => {
            setTransition(false)
        }, 500)

        return () => clearTimeout(timeOut)
    }, [isSticky])

    const favoriteType = location ? FavoriteType.Location : FavoriteType.Brand
    const favoriteItem = location ? location : brand
    return (
        <div
            className={classNames(
                'mx-auto flex w-full items-center justify-between bg-white lg:py-8 xl:justify-center',
                isSticky && 'mx-auto min-h-[6rem] py-0 md:h-[5.5rem]'
            )}
        >
            <div className='duration-400 mx-auto flex w-full flex-row justify-between px-4 opacity-100 transition-all ease-out lg:w-[1440px] xl:px-20'>
                <div className='flex w-3/4 flex-row items-center py-1 lg:py-0'>
                    <div
                        className={classNames(
                            'relative mr-6 h-20 w-20 scale-75 rounded-md lg:h-24 lg:min-w-24 lg:scale-100',
                            isSticky && 'overflow-hidden lg:scale-50'
                        )}
                    >
                        <UI.Media
                            asset={assets[0]}
                            width={300}
                            height={300}
                            customWrapperClasses={classNames(
                                'mx-auto object-cover',
                                isSticky && 'lg:object-fit'
                            )}
                            alt={'BreweryDB Logo'}
                        />
                    </div>
                    <div className=''>
                        <UI.Heading
                            size='h3'
                            type='h1'
                            id='page-title'
                            customClasses={classNames(
                                'bdb-location__title text-xl lg:text-4xl',
                                isSticky && 'lg:text-3xl'
                            )}
                        >
                            {title}
                        </UI.Heading>
                        <AddressRow address={address} />
                    </div>
                </div>
                {location && (
                    <div className='mt-2 flex justify-between pb-0 md:mt-0 md:items-end md:pb-4'>
                        <LegacyFavoritesButton
                            type={favoriteType}
                            hasText
                            ariaLabel={`Add ${location?.title} to Your Favorites`}
                            item={favoriteItem}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Header
